import React from 'react'

import ProfileView from './view/ProfileView'
import PerfilConfigIndex from './config/PerfilConfigIndex'

const profileRoutes = [
    {
        path: '/profile',
        exact: true,
        component: ProfileView,
    },
    {
        path: '/profile/config/:profileId',
        exact: true,
        component: PerfilConfigIndex,
    },
]

export default profileRoutes
